import React, { Component } from 'react';
import './Style.css';
import '../../../custom.css'
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';
import NotFound from '../../../images/empty.svg'

export class HomeCommunity extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            },
            myPlanList: [],
            planFeatured: [],
            goals: []
        }

    }

    componentDidMount() {
        this.GetPlanSubscribe();
        this.GetPlanFeature();
        this.GetGoalByUserId();
    }

    async GetPlanSubscribe() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/GetSubscribePlanByUserId?isHome=true`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ myPlanList: data });
            window["setSlick"]('.home-subscribe');
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Obteniendo mis planes.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetPlanFeature() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/GetPlansFriends`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ planFeatured: data })

            window["setSlick"]('.home-features');

        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Obteniendo los planes destacados.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async InsertPlanToUser(activity) {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },

            body: JSON.stringify({
                PlanId: this.state.selectedPlanId,
                Activity: activity
            })
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/InsertPlanToUser`, request);

        this.setState({ loading: false });
        document.querySelector('#btnCloseAddPlan').click();

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            window.location.href = `/comunidad/plan/detalle/${data.id}`;

            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'Te has activado a este plan correctamente',
                    Type: 'alert-success',
                    Show: true
                }
            });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No se puedo registrar el plan',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetGoalByUserId() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        const response = await fetch(`Letter/GetGoalByUserId`, request);
        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ goals: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando las metas',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    render() {

        return (
            <div>

                <div className="row mt-5">

                    <div className="col-12"><h2 className="align-middle text-center">Mi carta de logros</h2></div>
                    <div className="col-12">
                        <h6 className="align-middle text-center">Avance</h6>
                        <div class="progress">
                            {
                                this.state.goals.length > 0 ?
                                    <div class="progress-bar" role="progressbar" style={{ "width": `${parseInt(this.state.goals.filter(c => c.goalIsAlready && c.isActive).length * (100 / this.state.goals.filter(c => c.isActive).length))}%` }} aria-valuenow={parseInt(this.state.goals.filter(c => c.goalIsAlready && c.isActive).length * (100 / this.state.goals.filter(c => c.isActive).length))} aria-valuemin="0" aria-valuemax="100">{parseInt(this.state.goals.filter(c => c.goalIsAlready && c.isActive).length * (100 / this.state.goals.filter(c => c.isActive).length))}%</div>
                                    :
                                    <div class="progress-bar" role="progressbar" style={{"width": "0%"}} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">0</div>
                            }
                        </div>
                    </div>

                    <div class="fa-3x" hidden>
                        <i class="fa-solid fa-circle-plus fa-beat"></i>
                        <i class="fa-solid fa-heart fa-beat"></i>
                    </div>

                    <div className="col-4 mt-5" hidden>

                        <div className="row text-center action-greats">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="bi bi-file-image" viewBox="0 0 16 16">
                                <path d="M8.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                <path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8l-2.083-2.083a.5.5 0 0 0-.76.063L8 11 5.835 9.7a.5.5 0 0 0-.611.076L3 12V2z" />
                            </svg>
                        </div>
                        <div className="row text-center">Subir evidencia</div>
                    </div>
                    <div className="col-4 mt-5" hidden>
                        <div className="row text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="bi bi-envelope-open-heart" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.817l3.235 1.94a2.76 2.76 0 0 0-.233 1.027L1 7.384v5.733l3.479-2.087c.15.275.335.553.558.83l-4.002 2.402A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738l-4.002-2.401c.223-.278.408-.556.558-.831L15 13.117V7.383l-3.002 1.801a2.76 2.76 0 0 0-.233-1.026L15 6.217V5.4a1 1 0 0 0-.53-.882l-6-3.2ZM7.06.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765l6-3.2ZM8 7.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z" />
                            </svg>
                        </div>
                        <div className="row text-center">Abrir carta</div>
                    </div>
                    <div className="col-4 mt-5" hidden>
                        <div className="row text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="bi bi-chat-square-heart" viewBox="0 0 16 16">
                                <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12ZM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z" />
                                <path d="M8 3.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z" />
                            </svg>
                        </div>
                        <div className="row text-center">Nota al senior</div>
                    </div>
                </div>

                <h2 className="mt-5 text-center">Mis planes</h2>

                <div class="slider home-subscribe mt-5">

                    {this.state.myPlanList.map(e =>

                        <div class="list-group-item align-items-center">
                            <div class="image-parent">
                                <a href={`/comunidad/plan/detalle/${e.id}`} >
                                    <img src={e.photo} class="img-fluid" alt={e.title} />
                                </a>
                            </div>
                            <div className="no-flex mt-2">
                                {e.title}<br />
                                <div class="progress mt-2">
                                    <div class="progress-bar" role="progressbar" style={{ "width": parseInt(e.progressValues) + '%' }} aria-valuenow={parseInt(e.progressValues)} aria-valuemin="0" aria-valuemax="100">{parseInt(e.progressValues)}%</div>
                                </div>
                            </div>
                        </div>

                    )}
                </div>

                {
                    this.state.myPlanList.length == 0 ?
                        <div className="align-middle text-center">
                            <img className="not-found" src={NotFound} />
                            <h5 className="mt-4">No haz iniciado ningún plan</h5>
                        </div> : null
                }


                {
                    this.state.planFeatured.length == 0 ?
                        <div className="align-middle text-center">
                            <img className="not-found" src={NotFound} />
                            <h5 className="mt-4">Tus amigos no han iniciado plan</h5>
                        </div> :
                        <h2 className="mt-5 text-center">Planes de mis amigos</h2>
                }

                <div class="slider home-features mt-5">

                    {this.state.planFeatured.map(e =>

                        <div class="list-group-item align-items-center">
                            <div class="image-parent">
                                <img src={e.photo} class="img-fluid" alt={e.title} />

                            </div>
                            <div className="no-flex mt-2">
                                {e.title}<br />
                                {e.friendName}<br />
                                <div class="progress mt-2">
                                    <div class="progress-bar" role="progressbar" style={{ "width": e.progressValues + '%' }} aria-valuenow={e.progressValues} aria-valuemin="0" aria-valuemax="100">{e.progressValues}%</div>
                                </div>
                            </div>
                        </div>

                    )}
                </div>

                <div class="slider home-features mt-5" hidden>

                    {this.state.planFeatured.map(e =>

                        <div class="list-group-item align-items-center">
                            <div class="image-parent">
                                <img src={e.photo} class="img-fluid" alt={e.title} />
                               
                            </div>
                            <div className="no-flex mt-2">
                                {e.title}<br />
                                {
                                    e.userSubscribe ?
                                        <a className="btn btn-primary mt-2" href={`/comunidad/plan/detalle/${e.id}`} >Progreso</a>
                                        :
                                        <button type="button" class="btn btn-primary mt-2" data-toggle="modal" data-target="#subscribePlanModal" onClick={() => {
                                            this.setState({ selectedPlanId: e.id });
                                        }} >
                                            Iniciar
                                        </button>
                                }

                            </div>
                        </div>

                    )}
                </div>

                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }}/> : null}
                {this.state.loading ? <Loading /> : null}

                <div class="modal fade" id="subscribePlanModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Seguir plan</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                ¿Deseas que la comunidad vea la actividad de tú plan?
                            </div>
                            <div class="modal-footer">

                                <a href="javascript:void(0);" onClick={() => {
                                    this.InsertPlanToUser('Friends');
                                }}>Visible para amigos</a>

                                <a href="javascript:void(0);" onClick={() => {
                                    this.InsertPlanToUser('Private');
                                }}>Privado</a>

                                <a href="javascript:void(0);" id="btnCloseAddPlan" data-dismiss="modal">Cancelar</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
        );
    }
}
